export enum TelemetryType {
    INCREMENT = 'INCREMENT',
    GAUGE = 'GAUGE',
    TIMER = 'TIMER',
    OUTDATED_SCHEMA = 'OUTDATED_SCHEMA',
}